import LabelT from '@components/tailwind-components/Label/LabelT';
import type React from 'react';
import { Controller } from 'react-hook-form';
import type { IScheduleProps } from '../../../interfaces/IInputProps';

export const ScheduleInput: React.FC<IScheduleProps> = ({
  name,
  control,
  label,
}) => {
  const delimiter = ' ';

  return (
    <div className='relative'>
      <div className='mt-1'>
        <LabelT text={label} />
        <div className='flex mt-1'>
          <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange } }) => {
              const [timeValue, timeType] = value.includes(delimiter)
                ? value.split(delimiter)
                : ['', ''];

              return (
                <>
                  <input
                    id={`${name}.0`}
                    type='number'
                    className='flex-none w-[60px] h-[35px] py-1.5 px-2.5 border border-gray-200 text-sm leading-5 font-normal outline-none focus:border-primary-base focus:outline-none focus:shadow-none first:border-r-0 rounded-tl-md rounded-bl-md'
                    min={0}
                    max={24}
                    value={timeValue}
                    onChange={(val) => {
                      const newTimeValue = val.target.value;
                      const changedValue = `${newTimeValue}${delimiter}${timeType}`;
                      return onChange(changedValue);
                    }}
                  />
                  <select
                    id={`${name}.1`}
                    className='flex-none w-[85px] h-[35px] py-1.5 pl-2.5 pr-0 border border-gray-200 text-sm leading-5 font-normal outline-none focus:border-primary-base focus:outline-none focus:shadow-none last:border-l-0 last:rounded-r-md last:m-0 rounded-tr-md rounded-br-md'
                    value={timeType}
                    onChange={(val) => {
                      const newTimeType = val.target.value;
                      const changedValue = `${timeValue}${delimiter}${newTimeType}`;
                      return onChange(changedValue);
                    }}>
                    {['minutes', 'hours', 'days'].map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ScheduleInput;
